import React, {useEffect, useState} from "react";
import {Form, Select, Spin} from "antd";
import {APIv1} from "../../api";

const {Option} = Select;

const InnSelect = ({onSelectChange, userData, placeholder = "Select an option"}) => {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await APIv1.get("/order/value/inn/", {
                    headers: {Authorization: `Token ${userData.token}`},
                });
                if (response.status === 200) {
                    setOptions(response.data.results);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [userData]);

    return (
        <Form.Item
            rules={[{ required: true, message: 'Please select a value!' }]}
        >
            <Select
                showSearch
                virtual={false}
                allowClear={true}
                style={{ width: "100%" }}
                placeholder={placeholder}
                onChange={onSelectChange}
                loading={loading}
                filterOption={(input, option) =>
                    String(option?.children).toLowerCase().includes(input.toLowerCase())
                }
                styles={{
                    popup: {
                        root: {
                            maxHeight: 250,
                            overflowY: 'auto',
                        },
                    },
                }}
                listHeight={250}
            >
                {loading ? (
                    <Option disabled>
                        <Spin size="small" />
                    </Option>
                ) : (
                    options.map((item) => (
                        <Option key={item.id} value={item.inn}>
                            {item.inn}
                        </Option>
                    ))
                )}
            </Select>
        </Form.Item>
    );
};

export default InnSelect;
